<template>
    <div class="my-service">
        <mt-header fixed title="自助下单">
            <router-link to="/my" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="my-content">
            <mt-navbar v-model="selected">
                <mt-tab-item id="0">待服务</mt-tab-item>
                <mt-tab-item id="1">已服务</mt-tab-item>
                <mt-tab-item id="-1">已取消</mt-tab-item>
            </mt-navbar>
            <div class="content-body">
                <mt-tab-container v-model="selected">

                    <mt-tab-container-item :id="statu"  v-for="(statu,index) in status" :key="index" v-if="statu===selected">

                        <ul class="mui-table-view service-record-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="moreLoading" infinite-scroll-distance="0" infinite-scroll-immediate-check="false">
                            <!--li数据遍历循环部分-->
                            <li class="mui-table-view-cell service-block" v-for="item in list">
                                <div class="service-order-block">
                                    <div class="service-order-header">
                                        <div class="service-order-elder">订单号：{{ item.order_no }}</div><span class="service-status">{{ item.status }}</span>
                                    </div>
                                    <div class="service-block-body">
                                        <div class="service-order">
                                            <div class="service-order-thumb">
                                                <img src="../../../static/product-default.png"  />
                                            </div>
                                            <div class="service-order-info">
                                                <div class="service-order-title">{{ item.title }} <span>{{ item.type }}</span></div>
                                                <div class="service-order-tip">下单时间：{{ item.created_at }}</div>
                                                <div class="service-order-tip">预约日期：{{ item.expected_time }}</div>
                                            </div>
                                        </div>
                                        <div class="service-order-address">
                                            地址：{{ item.address }}
                                        </div>
                                        <div class="service-order-address">
                                            需求：{{ item.desc }}
                                        </div>
                                        <div class="service-order-address"  v-if="item.status_id=='1'">
                                            执行员工：<span>{{ item.carry_staff }}</span>
                                        </div>
                                    </div>
                                    <div class="receive-action" v-if="item.status_id=='0'">
                                        <div class="receive-action-button accept-button" @click="enterCarry(item.id)">
                                            执行服务
                                        </div>
                                        <div class="receive-action-button refuse-button" @click="cancel(item.id)">
                                            取消订单
                                        </div>
                                    </div>

                                </div>

                            </li>
                            <!--底部判断是加载图标还是提示“全部加载”-->
                            <li class="more_loading" v-show="queryLoading">
                                <mt-spinner class="spinner" type="fading-circle"  color="#ffcb01;" :size="25"></mt-spinner>
                            </li>
                            <li class="more_loading" v-show="!queryLoading">
                                <span class="loaded">已全部加载</span>
                            </li>
                        </ul>

                    </mt-tab-container-item>
                </mt-tab-container>
            </div>
        </div>
    </div>
</template>
<script>

    import GlOBAL from "@/api/global"
    import { MessageBox } from 'mint-ui'

    export default{
        data(){
            return {
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,

                status:['0','1','-1'],

                selected:"0",
                imgUrl:GlOBAL.imgUrl,

                //初始化无限加载相关参数
                list:[],
                queryLoading: true,
                pageNum:1,
            }
        },

        created(){
           this.getService(this.selected,this.pageNum);
        },

        watch:{
            selected:{
                handler(){
                    this.pageNum = 1;

                    this.queryLoading = true;
                    this.getService(this.selected,1,true);
                }
            }
        },

        methods:{
            getService(status,page,changed = false){
                this.$axios.get('/my/self?openid='+this.openid+'&status='+status+'&page='+page)
                    .then(data => {

                        if (data.data.code === 'OK') {


                            if(changed){
                                this.list = data.data.data;
                            }else{
                                this.list = this.list.concat(data.data.data);
                            }

                            if(data.data.data.length<10){
                                this.queryLoading = false;
                            }
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            },

            //无限加载函数
            loadMore() {

                if(!this.queryLoading){
                    return;
                }

                this.pageNum++;
                this.getService(this.selected,this.pageNum);

            },


            enterCarry(id){
                this.$router.push('/my/selfCarry/'+id);
            },

            cancel(id){
                let that = this;
                MessageBox.confirm('确定要取消该订单吗？').then(action => {
                    this.$indicator.open('加载中');

                    this.$axios.post("/my/cancelSelfOrder", {openid:this.openid,self_id:id})
                        .then(data => {

                            this.$indicator.close();

                            if (data.data.code === 'OK') {
                                this.$toast('取消成功!');
                                setTimeout(function(){
                                    window.location.reload();
                                },2000);
                            } else {
                                this.$toast(data.data.message);
                            }
                        });
                });
            }

        },

    }
</script>
<style scoped>
    .content-body{
        padding:20px;
    }

    .service-block{
        margin-bottom: 20px;
        background:#fff;
    }

    .service-order-header{
        padding:10px 20px;
        border-bottom:1px solid #f4f4f4;
        font-size:12px;
        color:#848a8f;
        display:flex;
        justify-content: space-between;
    }

    .service-block-body{
        padding:20px;
    }

    ul.service-record-list{
        margin:0
    }


    .service-tips span{
        font-size:12px;
    }


    .service-order{
        display:flex;
    }

    .service-order-thumb img{
        width: 50px;
        height: 50px;
        padding: 5px;
        border: 1px solid #dedede;
    }

    .service-order-info{
        padding-left:15px;
    }

    .service-order-info .service-order-title{
        font-size:14px;
        padding: 4px 0;
    }

    .service-order-info .service-order-tip{
        font-size:12px;
        color: #848a8f;
    }

    .service-order-address{
        font-size:12px;
        color: #848a8f;
        padding-top:10px;
    }

    .service-order-footer{
        background:#ffcb01;
        color:#fff;
        text-align:center;
        padding:10px 0;
        font-size:14px;
    }

    .service-order-title span{
        color:#ffcb01;
        padding-left:5px;
    }

    .service-carry-staff{
        font-size:12px;
        color: #848a8f;
        padding-top:10px;
    }

    .service-carry-staff span{
        color:#ffcb01;
        font-weight:600;
    }

    .receive-action{
        font-size:12px;
        text-align:center;
        color:#fff;
        display:flex;
    }

    .receive-action-button{
        flex:1;
        padding:10px 0;
    }

    .accept-button{
        background:#ffc107;
    }

    .refuse-button{
        background:#b8bbbf;
    }


    .service-carry-title{
        padding:10px 20px;
        border-bottom:1px solid #f4f4f4;
        border-top:1px solid #f4f4f4;
        font-size:12px;
        color:#848a8f;
        text-align:center;
    }
    .service-carry-staff{
        padding:10px 20px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/my/self.vue